import { icons } from "assets";
import Button from "Components/shared/button";
import { DebitCard } from "Components/shared/cards/DebitCard";
import Text from "Components/shared/text";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  fetchDebitCards,
  useGetUsersDebitCard,
} from "services/debitCardService";
import { Storage } from "utils/clientStorage";
import styles from "./container.module.css";

export const MyCard = ({ transaction }) => {
  const navigate = useNavigate();
  const [cardDetails, setCardDetails] = useState(null);
  // const {
  //   status: usersCardDetailsStatus,
  //   error: usersCardDetailsError,
  //   data: usersCardDetailsData,
  // } = useGetUsersDebitCard();

  // let data = usersCardDetailsData?.data.card;

  useEffect(() => {
    getCardDetails();
    // Storage.setItem("DOLLAR", data?.balance);
    // Storage.setItem("CARDNUMBER", data?.cardNumber);
    // Storage.setItem("DEBITCARD", data?.cardNumber);
  }, []);

  const getCardDetails = () => {
    fetchDebitCards()
      .then((res) => {
        let data = res.data.card;
        setCardDetails(data);
        Storage.setItem("DOLLAR", data?.balance);
        Storage.setItem("CARDNUMBER", data?.cardNumber);
        Storage.setItem("DEBITCARD", data?.cardNumber);
      })
      .catch((err) => console.log(err.message));
  };

  // console.log("DEBIT CARD ", usersCardDetailsData?.data.card);
  return (
    <Text tag="div" className={styles.todoContainer}>
      <Text tag="p" style={{ fontWeight: "600" }}>
        My Card
      </Text>
      <DebitCard
        cardNumber={
          cardDetails ? cardDetails?.cardNumber : "**** **** **** ****"
        }
        expiryDate={ cardDetails?.exp || "**/**"}
        // background="#CBD5E1"
        background={"linear-gradient(305.01deg, #0169FF -35.6%, #20BF6B 65.87%)"||  "#CBD5E1"
        }
        style={{ height: 175, flexBasis: 300 }}
        cardId={cardDetails?.cardId}
      />
      <Text style={{ color: "var(--secondary-text)" }}>Your Balance</Text>
      <Text
        tag="div"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "1rem 0",
          borderBottom: "1px solid var(--social-background)",
        }}
      >
        <Text style={{ fontWeight: "600" }}>${cardDetails?.balance}</Text>
        <img src={icons.refresh} />
      </Text>
      {!cardDetails?.cardNumber ? (
        <Button
          label="Apply for a Debit Card"
          style={{ width: "100%", marginTop: "1.5rem" }}
          onClick={() => navigate("debit-card")}
        />
      ) : (
        <Text
          tag="div"
          style={{
            display: "flex",
            justifyContent: "space-between",
            paddingTop: "1rem",
          }}
        >
          <Text tag="div">
            <Text style={{ fontWeight: "300" }}>Currency</Text>
            <Text style={{ fontWeight: "600" }}>{cardDetails?.currency}</Text>
          </Text>
          <Text tag="div">
            <Text style={{ fontWeight: "300" }}>Status</Text>
            <Text style={{ fontWeight: "600" }}>{cardDetails?.blocked ? "Inactive" : 'Active'}</Text>
          </Text>
        </Text>
      )}
    </Text>
  );
};
